import { useTranslation } from 'react-i18next';
import type { DashboardKpiColor, DashboardSummaryKpi } from '../../types/dashboard';
import { DashboardInfoTip } from './DashboardDateFilter';

type DashboardKpiGridProps = {
  kpis: DashboardSummaryKpi[];
  i18nPrefix: string;
  dateFromLabel: string;
  dateToLabel: string;
};

export function DashboardKpiGrid({ kpis, i18nPrefix, dateFromLabel, dateToLabel }: DashboardKpiGridProps) {
  const { t } = useTranslation();

  return (
    <div className="dash-kpi-grid">
      {kpis.map((kpi) => (
        <div key={kpi.key} className={`dash-kpi-card dash-kpi-card--${kpi.color as DashboardKpiColor}`}>
          <div className="dash-kpi-card__row">
            <span className="dash-kpi-card__label">{t(`${i18nPrefix}.kpis.${kpi.key}`)}</span>
            <DashboardInfoTip tooltip={kpi.tooltip} />
          </div>
          <div className="dash-kpi-card__value">{kpi.value.toLocaleString()}</div>
        </div>
      ))}
    </div>
  );
}